/**
 * App-wide event bus. Vue 3 removed $on/$off/$once from instances, so the old `new Vue()` bus is
 * replaced by this tiny emitter with the same method names.
 */
const handlers = new Map()

function list (event) {
  if (!handlers.has(event)) handlers.set(event, [])
  return handlers.get(event)
}

export const bus = {
  $on (event, fn) {
    (Array.isArray(event) ? event : [event]).forEach((e) => list(e).push(fn))
    return bus
  },
  $once (event, fn) {
    const wrapper = (...args) => {
      bus.$off(event, wrapper)
      fn(...args)
    }
    wrapper.fn = fn
    return bus.$on(event, wrapper)
  },
  $off (event, fn) {
    if (!event) { handlers.clear(); return bus }
    (Array.isArray(event) ? event : [event]).forEach((e) => {
      if (!fn) { handlers.delete(e); return }
      const arr = handlers.get(e)
      if (!arr) return
      const i = arr.findIndex((h) => h === fn || h.fn === fn)
      if (i >= 0) arr.splice(i, 1)
    })
    return bus
  },
  $emit (event, ...args) {
    const arr = handlers.get(event)
    if (arr) arr.slice().forEach((fn) => fn(...args))
    return bus
  }
}

export default bus
